import './_polyfills.js'

import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'
import 'lazysizes'
import 'focus-visible'

import * as conditioner from 'conditioner-core'
import { rIC } from 'idlize/idle-callback-polyfills.mjs'

conditioner.addPlugin({
  moduleSetName: name => `./ui/${name}.js`,
  moduleGetConstructor: module => module.default,
  moduleImport: name => import(/* webpackChunkName: 'conditioner' */ `${name}`),
  monitor: {
    name: 'idle',
    create: () => ({
      matches: false,
      addListener (change) {
        rIC(() => {
          this.matches = true
          change()
        })
      }
    })
  }
})

conditioner.hydrate(document.documentElement)

if (process.env.NODE_ENV !== 'production') {
  import(/* webpackChunkName: "BrowserGrid" */ '@parallaxagency/browsergrid').then(
    ({ BrowserGrid }) => {
      // eslint-disable-next-line no-unused-vars
      const browserGrid = new BrowserGrid([
        {
          width: 1110 + 30,
          cols: 12,
          gutter: 15,
          includeCenterLines: 6
        }
      ])
    }
  )
}

const $objectFitImages = [...document.querySelectorAll('[data-object-fit]')]
if ($objectFitImages) {
  import(/* webpackChunkName: "objectFit" */ 'objectFitPolyfill/dist/objectFitPolyfill.basic.min')
}


// WEBPACK FOOTER //
// ./src/js/main.js